import {SharedInputEdit} from '../../components/SharedInputEdit';
import {useContext} from 'react';
import {CalculatorAdvancedModeContext} from '../../../../shared/contexts/CalculatorContext';
import {CalculatorAdvancedMode} from '../../../../shared/classes/CalculatorMode';
import {CalculatorRembursement} from "../../components/CalculatorRembursement";

export function ClinicalExaminationsInput(): JSX.Element {
    const advancedMode = useContext(CalculatorAdvancedModeContext)!;

    return (
        <div className="examinations --ctow">

            <div>

                <div>

                    <h4>Data Inputs from Imaging Department</h4>

                    <SharedInputEdit inputName='average_number_of_procedures_per_day'/>
                    {/*<SharedInputEdit inputName='avg_reimbursement_per_exams_medical_devices'/>*/}
                    <CalculatorRembursement/>

                    <div className="price">
                        <div>
                            <SharedInputEdit inputName='high_examination_mix_price'/>
                            <SharedInputEdit inputName='medium_examination_mix_price'/>
                            <SharedInputEdit inputName='low_examination_mix_price'/>
                        </div>
                        <div>
                            <SharedInputEdit inputName='high_examination_mix_percent'/>
                            <SharedInputEdit inputName='medium_examination_mix_percent'/>
                            <SharedInputEdit inputName='low_examination_mix_percent'/>
                        </div>
                    </div>

                </div>

                <div>
                    {
                        advancedMode[0] === CalculatorAdvancedMode.Advanced
                            ? <div>

                                <h4>Data Inputs for Hospital Workflow</h4>

                                <SharedInputEdit inputName='hospital_avg_transfer_rate_when_system_is_down'/>
                                <SharedInputEdit inputName='hospital_transportation_fee_for_a_patient_transfer'/>
                                <SharedInputEdit inputName='hospital_avg_transfer_time_including_exam_time_in_hours'/>
                                <SharedInputEdit inputName='hospital_examination_fee'/>

                            </div>
                            : ''
                    }
                    {
                        advancedMode[0] === CalculatorAdvancedMode.Advanced
                            ? <div>
                                <h4>Data Inputs for Surgery Dpt Impact</h4>

                                <SharedInputEdit
                                    inputName="surgery_avg_surgeries_requiring_diagnostic_imaging_prior_to_surgery"></SharedInputEdit>
                            </div>
                            : ''
                    }
                </div>

            </div>

        </div>
    );
}
